<template lang="pug">
  .component-reject-driver-request-buttons(v-if="item.deleted_at === null")
    CreateBookingFromReservationRequest(:item="item")
    UpdateDriverReservationRequestStatus(:item="item")
    .dropdown-buttons
      ActionButton(:action="reject", confirm,  ) Delete request
</template>

<script>
import CreateBookingFromReservationRequest from "./CreateBookingFromReservationRequest.vue";
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from "../../../../maggieHelper";
import ActionButton from "../ActionButton.vue";
import {EventBus} from "src/eventBus";
import UpdateDriverReservationRequestStatus from "./UpdateDriverReservationRequestStatus.vue";

export default {
  name: "DriverReservationRequestButtons",
  components: {UpdateDriverReservationRequestStatus, ActionButton,  CreateBookingFromReservationRequest},
  methods: {
    reject() {
      return KeplerBackofficeSdk.reservations.rejectDriverRequestBooking(this.item.id, () => {
        EventBus.$emit('reload-list')

        MaggieHelper.notification('Driver booking request', 'deleted successfully')
      })
    }
  },
  props: ["item"]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DriverReservationRequestButtons.vue?29fc2eb7